import { useContext, useEffect, useState } from 'react';
import { LoginContext } from '../../contexts/LoginContext';
import { todayDate, todayLastYear, YMD_FORMAT } from '../../utils/DateUtils';
import purchaseOrdersApi from '../../services/purchaseOrdersApi';
import { AppContext } from '../../contexts/AppContext';

const usePurchaseOrdersPresenter = () => {
  const { isSupplier, idSupplier } = useContext(LoginContext);
  const { showError, showWarning } = useContext(AppContext);

  const [firstLoad, setFirstLoad] = useState(true);
  const [rows, setRows] = useState([]);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [purchaseOrderNumber, setPurchaseOrderNumber] = useState('');
  const [dateTo, setDateTo] = useState(null);
  const [dateFrom, setDateFrom] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    isSupplier && search();
  }, []);

  const cleanFilters = () => {
    setSelectedSupplier(null);
    setPurchaseOrderNumber('');
    setDateFrom(null);
    setDateTo(null);
  };

  const search = () => {
    const request = {
      Cuit: isSupplier ? idSupplier : selectedSupplier.cuit,
      StartDate: dateFrom ? dateFrom.format(YMD_FORMAT) : todayLastYear(),
      EndDate: dateTo ? dateTo.format(YMD_FORMAT) : todayDate(),
      PurchaseOrder: !purchaseOrderNumber.isBlank() ? purchaseOrderNumber : undefined,
    };

    setFirstLoad(false);
    setLoading(true);

    purchaseOrdersApi
      .getPurchaseOrders(request)
      .then(res => {
        res.data.forEach(r => (r.Cuit = request.Cuit));
        setRows(res.data);
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
        showError('Error al obtener los pedidos de compra');
      });
  };

  const validateFilters = () => {
    let errors = [];
    const errorMessages = [];
    let i = 0;

    if ((errors[i++] = !isSupplier && !selectedSupplier)) {
      errorMessages.push('Debe seleccionar un proveedor para iniciar la búsqueda');
    }

    if ((errors[i++] = dateFrom && !dateTo)) {
      errorMessages.push('Debe completar el rango de fechas o quitar la Fecha desde');
    }

    if ((errors[i++] = !dateFrom && dateTo)) {
      errorMessages.push('Debe completar el rango de fechas o quitar la Fecha hasta');
    }

    const hasErrors = errors.some(e => e);

    hasErrors && showWarning(errorMessages);

    return !hasErrors;
  };

  const validateAndSearch = () => validateFilters() && search();

  return {
    selectedSupplier,
    setSelectedSupplier,
    purchaseOrderNumber,
    setPurchaseOrderNumber,
    dateFrom,
    setDateFrom,
    dateTo,
    setDateTo,
    validateAndSearch,
    cleanFilters,
    rows,
    loading,
    firstLoad,
  };
};

export default usePurchaseOrdersPresenter;
